var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import SearchField from "@frameworks/salesjourney/components/Generic/SearchField";
import NoSearchResultMsg from "@frameworks/salesjourney/components/Generic/NoSearchResultMsg";
import { config } from "@frameworks/salesjourney/config/domain";
var AllReports = function (props) {
    var _a, _b, _c;
    var _d = __read(useState(""), 2), searchText = _d[0], setSearchText = _d[1];
    var _e = __read(useState([]), 2), searchedReport = _e[0], setSearchedReports = _e[1];
    var handleClick = function (report) {
        if (report.kpi_id === 64) {
            return (config.applicationFolder +
                "dashboard/rm-partners-reports/zerosing-report/" +
                btoa("".concat(report === null || report === void 0 ? void 0 : report.kpi_name)) +
                "/" +
                btoa("".concat(report === null || report === void 0 ? void 0 : report.kpi_id)));
        }
        return (config.applicationFolder +
            "dashboard/rm-partners-reports/" +
            btoa("".concat(report === null || report === void 0 ? void 0 : report.kpi_name)) +
            "/" +
            btoa("".concat(report === null || report === void 0 ? void 0 : report.kpi_id)));
    };
    useEffect(function () {
        var _a, _b, _c;
        if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) >= 2) {
            setSearchedReports((_b = (_a = props === null || props === void 0 ? void 0 : props.reports) === null || _a === void 0 ? void 0 : _a.apiData) === null || _b === void 0 ? void 0 : _b.filter(function (report) { var _a; return (_a = report === null || report === void 0 ? void 0 : report.kpi_name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase()); }));
        }
        else if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) === 0) {
            setSearchedReports((_c = props === null || props === void 0 ? void 0 : props.reports) === null || _c === void 0 ? void 0 : _c.apiData);
        }
    }, [searchText]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "p-3 position-sticky sticky-top bg-white" },
            React.createElement(SearchField, { searchText: searchText, setSearchText: setSearchText, placeholder: "Search Reports", searchIcon: "", parentClass: "search-input-block d-flex align-items-center" })),
        searchText ? (React.createElement(React.Fragment, null, (searchedReport === null || searchedReport === void 0 ? void 0 : searchedReport.length) ? (React.createElement("div", { className: "reports" }, (_a = searchedReport === null || searchedReport === void 0 ? void 0 : searchedReport.map) === null || _a === void 0 ? void 0 : _a.call(searchedReport, function (report) { return (React.createElement("div", { className: "one-report" },
            React.createElement("a", { href: handleClick(report) },
                React.createElement("span", { className: "DMSan_14_500 txt-midnight-blue cursor-pointer" }, report === null || report === void 0 ? void 0 : report.kpi_name)))); }))) : (React.createElement(NoSearchResultMsg, { message: React.createElement(React.Fragment, null,
                "Couldn\u2019t find anything!",
                React.createElement("br", null),
                "Try searching for something else") })))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "reports" }, (_c = (_b = props === null || props === void 0 ? void 0 : props.reports) === null || _b === void 0 ? void 0 : _b.apiData) === null || _c === void 0 ? void 0 : _c.map(function (report) { return (React.createElement("div", { className: "one-report" },
                React.createElement("a", { href: handleClick(report) },
                    React.createElement("span", { className: "DMSan_14_500 txt-midnight-blue cursor-pointer" }, report === null || report === void 0 ? void 0 : report.kpi_name)))); }))))));
};
export default AllReports;
